'use client'

import { signOut as clientSignOut } from 'next-auth/react'
import { parseAsBoolean, useQueryState } from 'nuqs'
import { useAppDispatch } from '@/lib/hooks'
import { setRegister as setRegisterAction } from '@/lib/redux'

export const useApp = () => {
  const [isLoading, setIsLoading] = useQueryState(
    'isLoading',
    parseAsBoolean.withOptions({ shallow: true }),
  )
  const dispatch = useAppDispatch()

  const setRegister = (register: any) => dispatch(setRegisterAction(register))

  const signOut = async () => {
    await clientSignOut({
      callbackUrl: '/onboard',
    })
  }

  return {
    isLoading,
    setIsLoading,
    setRegister,
    signOut,
  }
}
